module.exports = __webpack_public_path__ + "img/LOGO-反白.8c8b8ed2.png";